var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
function debounce(fn, delay) {
  var timeoutId = null;
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return fn.apply(void 0, __spreadArray([], __read(args), false));
    }, delay);
  };
}
export function useScrollShadowVisibility(scrollRef, delay, epsilon) {
  if (delay === void 0) {
    delay = 50;
  }
  if (epsilon === void 0) {
    epsilon = 2;
  }
  var _a = __read(useState(false), 2),
    showLeft = _a[0],
    setShowLeft = _a[1];
  var _b = __read(useState(false), 2),
    showRight = _b[0],
    setShowRight = _b[1];
  useEffect(function () {
    var scrollEl = scrollRef.current;
    if (!scrollEl) return;
    var update = function () {
      var scrollLeft = scrollEl.scrollLeft,
        scrollWidth = scrollEl.scrollWidth,
        clientWidth = scrollEl.clientWidth;
      setShowLeft(scrollLeft > 0);
      setShowRight(scrollLeft + clientWidth < scrollWidth - epsilon);
    };
    var debouncedUpdate = debounce(update, delay);
    update(); // initial
    scrollEl.addEventListener('scroll', debouncedUpdate);
    window.addEventListener('resize', debouncedUpdate);
    return function () {
      scrollEl.removeEventListener('scroll', debouncedUpdate);
      window.removeEventListener('resize', debouncedUpdate);
    };
  }, [scrollRef, delay]);
  return {
    showLeft: showLeft,
    showRight: showRight
  };
}